<template>

    <div>
 <v-row no-gutters>
      <base-header>
        <div slot="page-header">Technical Analysis</div>
      </base-header>
    </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <div id="chart2"></div>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <div id="chart3"></div>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <div id="chart4"></div>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <div id="chart5"></div>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart6"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart7"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart8"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart9"></div></div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart10"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart11"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart12"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart13"></div></div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart17"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart14"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body"> <div id="chart15"></div></div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                         <div slot="card-body"> <div id="chart16"></div></div>
                </base-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";

    import ChartGauge from "../../components/Charts/ChartGauge"
    export default {
        components: {
            BaseCard,
            ChartGauge,
BaseHeader
        },
        mounted() {
            var options = {
                series: [17],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#ff0000'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['BUY'],
            };

            var chart = new ApexCharts(document.querySelector("#chart2"), options);
            chart.render();

            var options = {
                series: [77],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.1,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart3"), options);
            chart.render();

            var options = {
                series: [64],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#ff0000'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['BUY'],
            };

            var chart = new ApexCharts(document.querySelector("#chart4"), options);
            chart.render();

            var options = {
                series: [87],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['BUY'],
            };

            var chart = new ApexCharts(document.querySelector("#chart5"), options);
            chart.render();
            var options = {
                series: [22],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart6"), options);
            chart.render();

            var options = {
                series: [57],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['BUY'],
            };

            var chart = new ApexCharts(document.querySelector("#chart7"), options);
            chart.render();
            var options = {
                series: [27],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart8"), options);
            chart.render();
            var options = {
                series: [47],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart9"), options);
            chart.render();
            var options = {
                series: [37],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart10"), options);
            chart.render();
            var options = {
                series: [67],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart11"), options);
            chart.render();
            var options = {
                series: [27],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart12"), options);
            chart.render();
                  var options = {
                series: [87],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart13"), options);
            chart.render();
          
                         var options = {
                series: [87],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart14"), options);
            chart.render();
                         var options = {
                series: [87],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['	#378b29'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart15"), options);
            chart.render();
                         var options = {
                series: [87],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['#ff0000'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart16"), options);
            chart.render();              var options = {
                series: [77],
                chart: {
                    height: 350,
                    type: 'radialBar',
                    offsetY: -10
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        dataLabels: {
                            name: {
                                fontSize: '16px',
                                color: undefined,
                                offsetY: 120
                            },
                            value: {
                                offsetY: 76,
                                fontSize: '22px',
                                color: undefined,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
                colors: ['#ff0000'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        shadeIntensity: 0.15,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    },
                },
                stroke: {
                    dashArray: 4
                },
                labels: ['SELL'],
            };

            var chart = new ApexCharts(document.querySelector("#chart17"), options);
            chart.render();

        }
    }
</script>